<template>
	<div>
		<van-sticky>
			<navbar :title="title" />
			<van-search v-model="list.search" placeholder="请输入搜索关键词" @search="onSearch"></van-search>
			<van-dropdown-menu>
				<van-dropdown-item v-model="list.order_status" :options="order_status" @change="onSearch" />
			</van-dropdown-menu>
		</van-sticky>

		<van-list
			v-model="list.loading"
			:finished="list.finished"
			offset="80"
			finished-text="没有更多了"
			@load="onLoad"
			style="padding-bottom: 50px;"
			ref="check"
		>
			<van-swipe-cell v-for="item in list.list" :key="item.order_id" :disabled="false">
				<van-cell class="item-list" @click="viewDetails(item.order_id)">
					<div class="user-title">
						<span class="user-title-name">
							<van-icon name="todo-list-o" />
							{{item.order_name}}
						</span>
						<span class="user-title-date" style="float: right;">{{item.create_date}}</span>
					</div>
					<div>
						<van-icon name="user-o" />
						{{item.client_name}}
					</div>
					<div style="float: left;">
						<van-icon name="cluster-o" />
						{{item.order_code}}
					</div>
					<van-tag
						plain
						:type="order_status[item.order_status].type"
						style="float: right; margin-top: 5px;"
					>{{order_status[item.order_status].text}}</van-tag>
				</van-cell>
			</van-swipe-cell>
		</van-list>

		<van-tabbar v-model="activeName">
			<van-tabbar-item name="list" icon="balance-list-o" to="/order/list">我的订单</van-tabbar-item>
			<van-tabbar-item name="index" icon="add-o" to="/order">新增订单</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
import navbar from "@/components/navBar/index";
import { post } from "@/api/order";
import { Toast } from "vant";

export default {
	components: {
		navbar
	},
	data() {
		return {
			title: "我的订单",
			activeName: "list",
			list: {
				requestType: "sales_order_list",
				list: [],
				loading: false,
				finished: false,
				page: 1,
				limit: 10,
				search: "",
				order_status: 0
			},
			order_status: [
				{ text: "财务审核", value: 0, type: "default" },
				{ text: "已审核", value: 1, type: "primary" },
				{ text: "审核拒绝", value: 2, type: "danger" },
				{ text: "分公司经理审批", value: 3, type: "warning" },
				{ text: "董事长审批", value: 4, type: "success" },
				{ text: "财务预审核", value: 5, type: "success" }
			]
		};
	},
	activated() {
		if (this.$route.params.refresh != true  && this.$route.params.refresh != undefined) {
			this.list.list = [];
			this.activeName = "list";
			this.list.finished = false;
			this.list.page = 1;
			this.list.order_status = 0;
			this.list.search = "";
			this.onLoad();
		}
	},
	methods: {
		onSearch() {
			// this.list.finished = false; //打开会报错重复加载等问题
			this.list.page = 1;
			this.onLoad();
		},
		mounted() {
			this.$refs.check();
		},
		onLoad() {
			let axiosData = new Object();
			axiosData.requestType = this.list.requestType;
			axiosData.page = this.list.page;
			axiosData.limit = this.list.limit;
			axiosData.search = this.list.search;
			axiosData.order_status = this.list.order_status;

			post(axiosData)
				.then(res => {
					if (res.obj.rows.length === 0) {
						this.list.finished = true;
					}
					if (this.list.page != 1) {
						this.list.list = this.list.list.concat(res.obj.rows);
					} else {
						this.list.list = res.obj.rows;
					}

					this.list.page += 1;
					this.list.loading = false;
				})
				.catch(err => {
					console.log(err);
					this.list.loading = false;
					this.list.finished = true;
					return Toast("数据异常");
				});
		},
		viewDetails(id) {
			this.$router.push({
				path: "/order/details",
				query: {
					id: id
				}
			});
		}
	}
};
</script>

<style>
</style>
